/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_TitleInputs */

const en_viewer_title = /** @type {(inputs: Viewer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online JSON Viewer`)
};

const ko_viewer_title = /** @type {(inputs: Viewer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온라인 JSON 뷰어`)
};

const ja_viewer_title = /** @type {(inputs: Viewer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインJSONビューアー`)
};

/**
* | output |
* | --- |
* | "Online JSON Viewer" |
*
* @param {Viewer_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_title = /** @type {((inputs?: Viewer_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_title(inputs)
	if (locale === "ko") return ko_viewer_title(inputs)
	return ja_viewer_title(inputs)
});